var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InteractionsServiceConstants, SERVICE } from "@agentx/agentx-services";
import { action, makeObservable, observable } from "mobx";
import { logger } from "../logger/store-logger";
export class InteractionsStore {
    constructor() {
        this.selectedInteraction = undefined;
        //observable.map was chosen to allow for a simpler integration with AGGrid, do not use unless you have a similar requirement
        this.activeInteractions = observable.map();
        this.queuedInteractions = observable.map();
        this.completedInteractions = observable.map();
        this.subscriptionIds = {
            [InteractionsServiceConstants.QueryType.Active]: undefined,
            [InteractionsServiceConstants.QueryType.Queued]: undefined
        };
        makeObservable(this);
    }
    subscribeToInteractions(queryType) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const updateCallback = this.createUpdateCallbackFunc(queryType);
                const subscriptionId = yield SERVICE.interactions.subscribeInteractionUpdates(queryType, updateCallback);
                this.subscriptionIds[queryType] = subscriptionId;
            }
            catch (error) {
                logger.error(`Error subscribing to ${queryType} interactions`, error);
                throw error;
            }
        });
    }
    stopInteractionUpdates(queryType) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const subscriptionId = this.subscriptionIds[queryType];
                if (subscriptionId) {
                    yield SERVICE.interactions.stopInteractionUpdates(subscriptionId);
                    this.subscriptionIds[queryType] = undefined;
                    this.getInteractionsMap(queryType).clear();
                }
            }
            catch (error) {
                logger.error(`Error stopping ${queryType} interaction updates`, error);
            }
        });
    }
    fetchCompletedInteractions(startTime, endTime, sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentQuery = { startTime, endTime, sortBy };
            if (JSON.stringify(this.lastCompletedInteractionsQuery) === JSON.stringify(currentQuery)) {
                if (this.completedNextPage) {
                    return this.completedNextPage();
                }
                return false;
            }
            this.lastCompletedInteractionsQuery = currentQuery;
            this.completedInteractions.clear();
            try {
                const { fetchMore } = yield SERVICE.interactions.fetchCompletedInteractions(startTime, endTime, (data) => this.handleCompletedCallback(data), sortBy);
                this.completedNextPage = fetchMore !== null && fetchMore !== void 0 ? fetchMore : null;
                return fetchMore !== null;
            }
            catch (error) {
                logger.error("Error fetching completed interactions.", error.message);
                throw error;
            }
        });
    }
    setSelectedInteraction(interactionId) {
        var _a, _b;
        if (interactionId !== "") {
            const interaction = (_b = (_a = this.activeInteractions.get(interactionId)) !== null && _a !== void 0 ? _a : this.queuedInteractions.get(interactionId)) !== null && _b !== void 0 ? _b : this.completedInteractions.get(interactionId);
            if (interaction) {
                this.selectedInteraction = interaction;
            }
        }
        else {
            this.selectedInteraction = undefined;
        }
    }
    handleCompletedCallback(data) {
        data.forEach((interaction) => {
            this.completedInteractions.set(interaction.id, interaction);
        });
    }
    createUpdateCallbackFunc(queryType) {
        return (data) => {
            if (data.fullUpdate) {
                this.handleFullUpdate(queryType, data.fullUpdate);
            }
            else if (data.realTimeUpdate) {
                this.handleRealTimeUpdate(queryType, data.realTimeUpdate);
            }
        };
    }
    handleFullUpdate(queryType, fullUpdate) {
        const interactionMap = observable.map(fullUpdate.map((item) => [item.id, item]));
        if (queryType === InteractionsServiceConstants.QueryType.Active) {
            this.activeInteractions = interactionMap;
        }
        else if (queryType === InteractionsServiceConstants.QueryType.Queued) {
            this.queuedInteractions = interactionMap;
        }
    }
    handleRealTimeUpdate(queryType, realTimeUpdate) {
        const targetMap = this.getInteractionsMap(queryType);
        this.updateInteractionsMap(targetMap, realTimeUpdate.updated, realTimeUpdate.removed);
    }
    getInteractionsMap(queryType) {
        return queryType === InteractionsServiceConstants.QueryType.Active
            ? this.activeInteractions
            : this.queuedInteractions;
    }
    updateInteractionsMap(targetMap, updated, removed) {
        if (updated) {
            updated.forEach((interaction) => {
                targetMap.set(interaction.id, interaction);
            });
        }
        if (removed) {
            removed.forEach((interactionId) => {
                targetMap.delete(interactionId);
            });
        }
    }
}
__decorate([
    observable
], InteractionsStore.prototype, "selectedInteraction", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "activeInteractions", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "queuedInteractions", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "completedInteractions", void 0);
__decorate([
    action
], InteractionsStore.prototype, "subscribeToInteractions", null);
__decorate([
    action
], InteractionsStore.prototype, "stopInteractionUpdates", null);
__decorate([
    action
], InteractionsStore.prototype, "fetchCompletedInteractions", null);
__decorate([
    action
], InteractionsStore.prototype, "setSelectedInteraction", null);
__decorate([
    action
], InteractionsStore.prototype, "handleCompletedCallback", null);
__decorate([
    action
], InteractionsStore.prototype, "handleFullUpdate", null);
__decorate([
    action
], InteractionsStore.prototype, "updateInteractionsMap", null);
